export const SMSTestingMutation = (builder) => ({
    smsTesting: builder.mutation({
      query: (credentials) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: '/sms/test',
          method: 'POST',
          body: credentials,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token 
          },
        };
      },
    }),
  });